import React from 'react';
import Translation from "@Translation/components/Translation";
import IconDiscountLabel from "@Icons/IconDiscountLabel";
import Row from "@Containers/components/Row";

interface DiscountBadgeProps {
    isActive: boolean,
    discountAmount: number,
}

const DiscountBadge = ({discountAmount, isActive}: DiscountBadgeProps) => {
    const style = !isActive ? {opacity: 0.3} : {}

    return (
        <Row
            center
            className="route--discount__badge"
            style={style}
        >
            <span>
                <Translation translationKey="search_results.web_discount"/>
            </span>
            <IconDiscountLabel
                discountText={`${discountAmount}%`}
            />
        </Row>
    )
};

export default DiscountBadge;